import {requirePermission} from '@/modules/auth/permissions'
import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {MobileLayout} from '@/modules/layout/app-layout/components/mobile-layout'
import {useBreakpointValue} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/reports')({
  beforeLoad: requirePermission('reports.view'),
  component: ReportsLayout,
})

function ReportsLayout() {
  const {t} = useTranslate('reports')
  const isMobile = useBreakpointValue({base: true, md: false}) ?? false
  return isMobile ? <MobileLayout title={t('reports')} /> : <AppLayout hideSideDrawer />
}
